var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_281)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150
  }), /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "#00864E",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3453 82.1973H37.3443C36.0485 82.1973 35 83.2458 35 84.5415V112.672C35 113.968 36.0485 115.017 37.3443 115.017H42.3453C46.2233 115.017 49.3781 111.862 49.3781 107.984V89.23C49.3781 85.352 46.2235 82.1973 42.3453 82.1973Z",
    fill: "#00864E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.314 86.7477C114.032 86.279 113.657 85.9037 113.235 85.5755C111.509 84.0655 108.601 84.2082 106.906 86.0446L96.2631 98.3284L95.9349 98.7033C94.6223 100.157 92.7467 100.954 90.7777 100.954H72.5863C71.2734 100.954 70.2421 99.9223 70.2421 98.6097C70.2421 97.2968 71.2734 96.2655 72.5863 96.2655H86.8862C89.4649 96.2655 91.5747 94.1556 91.5747 91.577V91.5301C91.5279 88.9514 89.4649 86.8885 86.8862 86.8885H78.4001C76.9942 86.8885 75.4876 86.3723 74.2742 85.3411C68.5544 80.3244 60.2087 79.9962 54.0668 84.2629V113.097C58.7084 114.363 63.4907 115.019 68.3197 115.019H89.2305C94.3877 115.019 99.2639 112.581 102.358 108.455L113.611 93.4522C115.252 91.2972 115.376 88.3419 114.314 86.7477Z",
    fill: "#00864E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8586 39.5314C95.2585 36.6092 91.6541 35 87.7095 35C83.3067 35 79.4901 37.0818 76.6725 41.0203C76.4612 41.3156 76.2635 41.6109 76.0783 41.9032C75.8933 41.6108 75.6956 41.3156 75.4843 41.0203C72.6667 37.0818 68.8501 35 64.4473 35C60.5027 35 56.8983 36.6092 54.2984 39.5313C51.831 42.3044 50.472 46.0115 50.472 49.97C50.472 54.2717 52.1412 58.2412 55.7248 62.4624C58.8519 66.1452 63.337 69.9308 68.5303 74.3143C70.4495 75.9341 72.4341 77.6092 74.543 79.4369C74.9836 79.8187 75.5309 80.0097 76.0783 80.0097C76.6256 80.0097 77.1731 79.8187 77.6137 79.4369C79.7222 77.6095 81.7066 75.9346 83.6257 74.315C86.9611 71.4998 89.8416 69.0686 92.3412 66.7103C97.1942 62.1315 101.685 56.9343 101.685 49.9702C101.685 46.0117 100.326 42.3045 97.8586 39.5314Z",
    fill: "#00864E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.30027af25625f425bd4890d97a9a00e9.svg";
export { ForwardRef as ReactComponent };